import React from 'react';
import { Table, Tag, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const imageColumns = [
  {
    title: 'Image Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Android Version',
    dataIndex: 'version',
    key: 'version',
  },
  {
    title: 'Tags',
    key: 'tags',
    dataIndex: 'tags',
    render: (tags: string[]) => (
      <>
        {tags.map(tag => {
          let color = tag.length > 5 ? 'geekblue' : 'green';
          if (tag === 'beta') {
            color = 'volcano';
          }
          return (
            <Tag color={color} key={tag}>
              {tag.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: 'Upload Date',
    dataIndex: 'uploadDate',
    key: 'uploadDate',
  },
];

const imageData = [
  {
    key: '1',
    name: 'aosp_arm64-userdebug-android12-gsi.img',
    version: '12.0',
    tags: ['stable', 'android-12'],
    uploadDate: '2025-10-28',
  },
  {
    key: '2',
    name: 'aosp_arm64-userdebug-android13-gsi.img',
    version: '13.0',
    tags: ['stable', 'android-13'],
    uploadDate: '2025-11-05',
  },
  {
    key: '3',
    name: 'custom_rom_beta_v0.2.img',
    version: '13.1',
    tags: ['beta'],
    uploadDate: '2025-11-09',
  },
];

const uploadProps = {
  name: 'file',
  action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76', // Mock upload URL
  headers: {
    authorization: 'authorization-text',
  },
  onChange(info: any) {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};

const ImageManagement = () => {
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />}>Upload New Image</Button>
        </Upload>
      </div>
      <Table columns={imageColumns} dataSource={imageData} />
    </div>
  );
};

export default ImageManagement;
